var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0766 2.71231C8.67724 2.78771 9.30856 2.94221 9.95517 3.22731C12.8771 4.51563 14.2003 7.92602 12.912 10.8479C11.621 13.7759 8.2106 15.0992 5.28869 13.8109C2.36677 12.5225 1.04353 9.11216 2.33185 6.19024C2.8106 5.10444 3.58648 4.23707 4.51885 3.64271",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25564 2.5252L9.9115 1.27728",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25593 2.5253L8.65 4.93231",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2655 10.4706L7.74589 9.56376C7.48119 9.40689 7.2655 9.02944 7.2655 8.72062V6.71082",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadBlack);
export default __webpack_public_path__ + "static/media/Reload_black.511fbcdd685b60f54a43c8aebb08daff.svg";
export { ForwardRef as ReactComponent };